import { APP_NAME_PULSE_WEB } from 'solaris-lens-common-lib/src/constants';
import { POWER_POOL_NAME } from 'solaris-lens-common-lib/src/constants/services';

import packageJson from '../../package.json';

export const POOL_NAME = POWER_POOL_NAME;
export const APP_NAME = APP_NAME_PULSE_WEB;
export const APP_VERSION = packageJson.version;
